import { Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import CauseContent from "@/components/Barriers/CauseContent";
import Page from "@/components/Page";

function Barriers() {
  return (
    <Page contentPadding maxWidth="xl">
      <Typography align="center" sx={{ my: 3 }} variant="h1">
        Barrierer
      </Typography>
      <CauseContent />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/barrierer")({
  component: Barriers,
});
